import { Component, OnInit} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { RestApiService } from 'src/app/core/api/rest-api.service';
import { AuthService } from 'src/app/core/common/auth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  public isCollapsed: any = [];
  public roleName: any = '';
  // header: any;
  showTemplate = false;
  ngAfterViewInit() {
    setTimeout(() => {
      this.showTemplate = true;
    }, 1000); // Delay in milliseconds
  }
  constructor(private _auth: AuthService, private router: Router,
    public _api: RestApiService,
    private _sanitizer: DomSanitizer,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this._auth.getRoleName.subscribe((item: any) => {
      this.roleName = item;
      this.getPropertyDetails();
    });
    this.isCollapsed['product'] = false;
    this.isCollapsed['category'] = false;
    this.isCollapsed['modifiers'] = false;
    this.isCollapsed['Global'] = false;
    this.isCollapsed['subModifiers'] = false;
    this.isCollapsed['typeModifiers'] = false;
    this.isCollapsed['section'] = false;
    this.isCollapsed['table'] = false;
    this.isCollapsed['venue'] = false;
    this.isCollapsed['transaction'] = false;
    this.isCollapsed['usermanagement'] = false;
    this.isCollapsed['tagManagement'] = false;
    this.isCollapsed['promoCode'] = false;
    this.isCollapsed['calorie'] = false;
    this.isCollapsed['tags'] = false;
    this.isCollapsed['venueTransaction']=false;
    
  }

  itemImage: any = '';
  getPropertyDetails() {
    this._api.getPropertyList({}).subscribe((data) => {
      // console.log(data);
      if (data.propertyList) {
        this.itemImage = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + data.propertyList[0].icon);
      } else {
        this.itemImage = "./assets/images/logo.png"
      }
    });
  }

  toggleMenu() {
    const body = document.querySelector('body');
    if (body) {
      body.classList.toggle('sidebar-main');
    }
  }

  


  activeMenu(menu: string) {
    let previousState = false;
    if (typeof this.isCollapsed[menu] != 'undefined') {
      previousState = !this.isCollapsed[menu];
    } else {
      previousState = !this.isCollapsed[menu];
    }
    this.isCollapsed = [];
    this.isCollapsed[menu] = previousState;

    // this.header = menu;
    // console.log(this.header);

  }

  getDashboard() {
    this.router.navigate(['/dashboard']);
  }

  getHelpdesk() {
    this.router.navigate(['/helpdesk']);
  }
}
